<template>
  <div class="service py-4 lg:pb-6 lg:pt-12 px-2 md:px-8 xl:px-10 max-w-7xl mx-auto" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="flex flex-col lg:flex-row">
      <div class="w-full lg:w-1/4 lg:pr-3 xl:pr-4">
        <SideMenu />
      </div>
      <div class="w-full lg:w-3/4 lg:pl-3 xl:pl-4">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/company/SideMenu'
export default {
  name: 'Company',
  data () {
    return {
    }
  },
  components: {
    SideMenu
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
</style>
